/**
 * Realperson
 *
 * @package    Utils JS (realpersonUtils)
 * @author     Nils Roeder <nils.roeder@rtbytes.com>
 * @maintainer Nils Roeder <nils.roeder@rtbytes.com>
 * @copyright  (c) optimise-it GmbH
 * @link       http://www.optimise-it.de/
 */
var realpersonUtils = (function(){
	// ajax timeout of 20 seconds
	var timeout			= 20000;

	/**
	 * ajax request handler
	 * sends ajax requests to php controller
	 */
	function queryServer(data, url, successCallback, failureHandler){

		$.ajax({
			type: "POST",
			url: url,
			cache: false,
			data: data,
			datatype: "json",
			timeout: timeout,
			success: successCallback,
			error: failureHandler
		});
	}

	/**
	 * send standardised success page alert using pixadmin
	 */
	function alertSuccessPixeladmin(message, extraClasses){
		$('.px-content').pxBlockAlert(message, { style: 'dark', type: 'success', timer: 3 });
	}

	/**
	 * send standardised error page alert using pixadmin
	 */
	function alertFailurePixeladmin(message, extraClasses){
		$('.px-content').pxBlockAlert(message, { style: 'dark', type: 'danger', timer: 3 });
	}

	/**
	 * set user settings
	 */
	function setUserSettings(data){
		queryServer({data: data}, '/user-settings', function(){}, function(){});
	}

	/**
	 * delete user settings
	 */
	function deleteUserSettings(data){
		queryServer({data: data}, '/user-settings/delete', function(){}, function(){});
	}

    /**
     * Tabellenauflistung anhand der gesetzten Filter bereinigen
     * 
     * Mögiche Filter sind:
     * single html <tr data-groupid="1">
     * multi html  <tr data-groupid="[1,2,3]">
     *
     * single filter: filter[ "group" ] = { "key": "groupid", "value": 1 };
     * multi filter:  filter[ "group" ] = { "key": "groupid", "value": [1,5] };
     * bool filter:   filter[ "group" ] = { "key": "groupid", "value": true }; // html attribut wird auf bool gecastet
     */
    function filterTableList(table, filter) {

        // alle Elemente sichtbar schalten
        $.fn.dataTable.ext.search.pop();
        table.draw();

        // im Filter gesetzte Elemente ausblenden
        $.fn.dataTable.ext.search.push(
            function( settings, data, dataIndex ) {

                var returnValue = true;
                var idList = null;
                var findValue = null;
                var tableValue = null;

                for ( var i in filter ) {
                    findValue = null;

                    if ( ( typeof filter[ i ].key !== 'undefined' ) && filter[ i ].key != '' && ( ( typeof filter[ i ].value !== "object" && filter[ i ].value != null ) || (  typeof filter[ i ].value === "object" && filter[ i ].value.length > 0 ) ) && ( typeof filter[ i ].orientation === 'undefined' || filter[ i ].orientation == 'row' ) ) {

                        tableValue = $( table.row( dataIndex ).node() ).data( filter[ i ].key );

                        idList = [];
                        if ( typeof tableValue === 'object' ) {
                            idList = tableValue;
                        }

                        // Tabellen-Value casten wenn Zielwert Boolean ist
                        if ( typeof filter[ i ].value === 'boolean' ) {
                            tableValue = Boolean( JSON.parse( tableValue ) );
                        }

                        if ( typeof filter[ i ].value !== 'object' ) {
                            findValue = jQuery.inArray( Number(filter[ i ].value ), idList );
                        } else {
                            filterValues = filter[ i ].value;
                            filterValues.forEach( function( entry ) {
                                if ( findValue == null || findValue == -1 ) {
                                    findValue = jQuery.inArray( Number( entry ), idList );
                                }
                            });
                        }

                        // prüfen ob wert NICHT vorhanden ist, dann... (erst single Filter, dann multi Filter)
                        if ( ( typeof tableValue !== 'object' && ( ( typeof filter[ i ].value !== 'object' && tableValue != filter[ i ].value ) || ( typeof filter[ i ].value === 'object' && jQuery.inArray( String( tableValue ), filter[ i ].value ) == -1 ) ) )
                            || ( ( (typeof filter[ i ].value !== 'object' &&  filter[ i ].value != 0 ) || ( typeof filter[ i ].value === 'object' ) ) && typeof tableValue === 'object' && findValue == -1 )
                        ) {
                            returnValue = false;
                        }
                    }
                }

                return returnValue;
            }
        );
        table.draw();
    }

	return{
		queryServer: queryServer,
		alertSuccessPixeladmin: alertSuccessPixeladmin,
		alertFailurePixeladmin: alertFailurePixeladmin,
		setUserSettings: setUserSettings,
		deleteUserSettings: deleteUserSettings,
        filterTableList: filterTableList,
	};
}(realpersonUtils));
